module.exports = __webpack_public_path__ + "static/media/ke.12a32814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ke.png
// module id = 1893
// module chunks = 0